import { useQuery } from "@tanstack/react-query";
import chatsService from "services/admin/chatsService";

export const useGetChatMessages = (chatID) => {
    return useQuery({
        queryKey: ['chat', chatID],
        queryFn: async () => {
            const response = await chatsService.getMessagesByChatID(chatID);
            return response.data?.rows || [];
        },
    enabled: !!chatID,
    refetchOnWindowFocus: false,
  });
};